import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  imports: [RouterLink],
  templateUrl: './device-not-activated.component.html',
})
export class DeviceNotActivatedComponent {}
